export default __webpack_public_path__ + "static/media/suc.53ffea53.png";